var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgesPathwayBackgroundRightA12 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 1145.22 2039.71",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;opacity:.31;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1110.36,281.5c7.74,78.66-3.38,155.82-29,230.32-24.57,71.44-60.58,139.9-75.29,214.47-20.88,105.87,31.9,202.44,71.01,297.05,41.92,101.42,53.21,202.13-15.85,295.54-18.47,24.99-40.88,47.32-55.53,74.73-32.6,61.02-33.4,158.61,16.52,210.83,93.63,97.96-15.26,264.49,0,357.45,12.88,78.47,123,78.47,123,78.47V0c-3.05-.08-231.53,0-231.53,0,115.76,94.87,187.95,192.86,196.67,281.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgesPathwayBackgroundRightA12, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgesPathwayBackground_RightA12.584a9991.svg";
export { ForwardRef as ReactComponent };